import React from "react";
import {
  Box,
  Button,
  Heading,
  HStack,
  Icon,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { ShieldCheck, CalendarCheck2, MessageSquareText } from "lucide-react";
import OnboardingLayout from "../components/onboarding/OnboardingLayout";

const steps = [
  {
    title: "Connect your scheduling system",
    why:
      "We’ll use your provider schedule to create recommendations on the best spot for same day bookings.",
  },
  {
    title: "Set your worker availability",
    why: "We need to know your worker schedule to identify gaps in that schedule.",
  },
];

const tools = [
  {
    title: "Accept last minute appointments",
    desc: "Turn open time into revenue without scrambling.",
    icon: ShieldCheck,
  },
  {
    title: "Increase conversions by showing off your availability on your website",
    desc: "Let customers see you can come sooner.",
    icon: CalendarCheck2,
  },
  {
    title:
      "Set up a waitlist and text your clients to fill in openings in your schedule",
    desc: "Automate the “want something sooner?” follow-up.",
    icon: MessageSquareText,
  },
];

export default function Onboarding() {
  return (
    <OnboardingLayout
      title="Welcome to Onboarding"
      subtitle="There are a few things we need you to do to get all set up."
    >
    <Heading size="sm" color="gray.900">
          Once you’re set up, we’ll show you how to use the three new tools in your toolbelt:
        </Heading>

        <Stack spacing={3} mt={4}>
          {tools.map((tool) => (
            <HStack
              key={tool.title}
              spacing={3}
              align="center"
              border="1px solid"
              borderColor="gray.200"
              bg="white"
              borderRadius="md"
              p={3}
            >
              <Box
                w="36px"
                h="36px"
                borderRadius="12px"
                border="1px solid"
                borderColor="gray.200"
                bg="gray.50"
                display="grid"
                placeItems="center"
                flexShrink={0}
              >
                <Icon as={tool.icon} boxSize={4} color="blue.600" display="block" />
              </Box>
              <Box flex="1">
                <Text fontWeight="700" fontSize="sm" color="gray.900">
                  {tool.title}
                </Text>
                <Text fontSize="sm" color="gray.600">
                  {tool.desc}
                </Text>
              </Box>
            </HStack>
          ))}
        </Stack>

      <Box
        mt={6}
        border="1px solid"
        borderColor="gray.200"
        borderRadius="lg"
        bg="gray.50"
        p={{ base: 5, md: 6 }}
      >

        <Stack mt={6} spacing={3} align="center">
          <Button
            as="a"
            href="/onboarding/connect-provider"
            size="md"
            borderRadius="md"
            colorScheme="blue"
            fontWeight="700"
            px={6}
          >
            Let’s Get Started
          </Button>

          <HStack spacing={2} color="gray.500" fontSize="sm">
            <Text>No credit card required</Text>
            <Box w="6px" h="6px" bg="gray.400" borderRadius="999px" />
            <Text>You can change settings anytime</Text>
          </HStack>
        </Stack>
      </Box>
    </OnboardingLayout>
  );
}
